// import React, { useState } from 'react';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     message: '',
//   });

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Handle form submission logic (e.g., send the form data to the server)
//     console.log('Form Submitted:', formData);
//   };

//   return (
//     <div className="bg-gray-50 p-8">
//       <header className="text-center mb-12">
//         <h1 className="text-4xl font-extrabold text-blue-700 mb-4 tracking-tight">Contact Us</h1>
//         <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-4">
//           Feel free to reach out to us for any inquiries or assistance. We're here to help! At Home Electric, we are
//           dedicated to providing the best assistance to our customers, and we are always available to support you in any way we can.
//           Visit our website for more information.
//         </p>
//       </header>

//       <section className="max-w-4xl mx-auto mb-12 px-4 sm:px-6">
//         <h2 className="text-3xl font-semibold text-gray-800 mb-6">Our Address</h2>
//         <p className="text-base text-gray-700 mb-4">
//           <strong>HO:</strong> No 14, Ashoka Mews, Khondhwa Khurd, Pune 411048 Maharashtra
//         </p>
//         <p className="text-base text-gray-700 mb-4">
//           <strong>Phone:</strong> 9123418583
//         </p>
//         <p className="text-base text-gray-700 mb-4">
//           <strong>Email:</strong> care@homeelectric.co.in
//         </p>
//       </section>

//       <section className="max-w-4xl mx-auto mb-12 px-4 sm:px-6 bg-white shadow-lg rounded-lg">
//         <h2 className="text-3xl font-semibold text-gray-800 mb-6">Get In Touch</h2>
//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//             <div>
//               <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">First Name</label>
//               <input
//                 type="text"
//                 name="firstName"
//                 id="firstName"
//                 value={formData.firstName}
//                 onChange={handleChange}
//                 className="mt-2 p-3 w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
//                 required
//               />
//             </div>
//             <div>
//               <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">Last Name</label>
//               <input
//                 type="text"
//                 name="lastName"
//                 id="lastName"
//                 value={formData.lastName}
//                 onChange={handleChange}
//                 className="mt-2 p-3 w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
//                 required
//               />
//             </div>
//           </div>

//           <div>
//             <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
//             <input
//               type="email"
//               name="email"
//               id="email"
//               value={formData.email}
//               onChange={handleChange}
//               className="mt-2 p-3 w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
//               required
//             />
//           </div>

//           <div>
//             <label htmlFor="message" className="block text-sm font-medium text-gray-700">Message</label>
//             <textarea
//               name="message"
//               id="message"
//               value={formData.message}
//               onChange={handleChange}
//               className="mt-2 p-3 w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
//               rows="4"
//               required
//             />
//           </div>

//           <div className="text-center">
//             <button
//               type="submit"
//               className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 transition"
//             >
//               Send
//             </button>
//           </div>
//         </form>
//       </section>

//       <footer className="text-center text-gray-700 mt-12">
//         <p className="text-sm">
//           © 2025 Home Electric. All rights reserved.
//         </p>
//       </footer>
//     </div>
//   );
// };

// export default Contact;



import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { BsLightningChargeFill } from 'react-icons/bs';
import { MdLocationOn, MdPhone, MdEmail, MdAccessTime } from 'react-icons/md';
import { HiOutlineUser, HiOutlineMail } from 'react-icons/hi';

const INFO = [
  { icon: <MdLocationOn />, label: 'Address', value: 'Udaipur, Rajasthan, India' },
  { icon: <MdPhone />, label: 'Phone', value: '+91 8963008378' },
  { icon: <MdEmail />, label: 'Email', value: 'fiercfly@gmail.com' },
  { icon: <MdAccessTime />, label: 'Hours', value: 'Mon–Sat: 9 AM – 6 PM' },
];

export default function Contact() {
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handle = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      toast.success('Message sent! Well get back to you soon.');
      setForm({ firstName: '', lastName: '', email: '', message: '' });
      setLoading(false);
    }, 1000);
  };

  return (
    <div
      className="min-h-screen py-16 px-4 md:px-6 relative"
      style={{ background: 'linear-gradient(160deg, var(--bg-void) 0%, var(--bg-deep) 100%)' }}
    >
      {/* Blob */}
      <div className="pointer-events-none absolute"
        style={{
          bottom: '20%', right: '10%', width: 500, height: 500,
          background: 'radial-gradient(circle, rgba(0,255,240,0.06) 0%, transparent 70%)',
          filter: 'blur(90px)'
        }} />

      <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="text-center mb-12 animate-fade-up">
          <p className="section-eyebrow justify-center mb-3">Reach Us</p>
          <h1 className="font-display text-4xl font-bold mb-3"
            style={{ color: 'var(--text-primary)' }}>
            CONTACT <span className="text-gradient">US</span>
          </h1>
          <p className="max-w-md mx-auto text-sm" style={{ color: 'var(--text-secondary)' }}>
            Questions, support, or just want to say hello — we're always happy to hear from you.
          </p>
        </div>

        <div className="grid md:grid-cols-5 gap-6">

          {/* Info column */}
          <div className="md:col-span-2 flex flex-col gap-4">
            {INFO.map(({ icon, label, value }, i) => (
              <div
                key={label}
                className="glass-card rounded-2xl p-5 flex items-start gap-4 animate-fade-up"
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 text-lg"
                  style={{ background: 'var(--indigo-dim)', color: 'var(--indigo-light)' }}
                >
                  {icon}
                </div>
                <div>
                  <p className="font-mono text-xs mb-0.5 tracking-wider uppercase"
                    style={{ color: 'var(--text-muted)' }}>
                    {label}
                  </p>
                  <p className="text-sm font-medium" style={{ color: 'var(--text-primary)' }}>
                    {value}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Form */}
          <div className="md:col-span-3 animate-fade-up delay-200">
            <form
              onSubmit={submit}
              className="glass rounded-2xl p-8 flex flex-col gap-5"
              style={{ border: '1px solid var(--glass-border)' }}
            >
              {/* Name row */}
              <div className="grid grid-cols-2 gap-4">
                {[
                  { name: 'firstName', label: 'First Name', placeholder: 'John', Icon: HiOutlineUser },
                  { name: 'lastName', label: 'Last Name', placeholder: 'Doe', Icon: HiOutlineUser },
                ].map(({ name, label, placeholder, Icon }) => (
                  <div key={name}>
                    <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                      style={{ color: 'var(--text-muted)' }}>{label}</label>
                    <div className="relative">
                      <Icon className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
                        style={{ color: 'var(--text-muted)' }} />
                      <input
                        type="text" name={name} placeholder={placeholder}
                        className="input-glass pl-9 pr-3 py-2.5 rounded-xl text-sm"
                        value={form[name]} onChange={handle} required
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* Email */}
              <div>
                <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                  style={{ color: 'var(--text-muted)' }}>Email</label>
                <div className="relative">
                  <HiOutlineMail className="absolute left-3 top-1/2 -translate-y-1/2 text-lg pointer-events-none"
                    style={{ color: 'var(--text-muted)' }} />
                  <input
                    type="email" name="email" placeholder="you@example.com"
                    className="input-glass pl-10 pr-4 py-3 rounded-xl"
                    value={form.email} onChange={handle} required
                  />
                </div>
              </div>

              {/* Message */}
              <div>
                <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                  style={{ color: 'var(--text-muted)' }}>Message</label>
                <textarea
                  name="message" rows={5}
                  placeholder="How can we help you?"
                  className="input-glass py-3 px-4 rounded-xl resize-none"
                  value={form.message} onChange={handle} required
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="btn-primary py-3.5 rounded-xl flex items-center justify-center gap-2"
              >
                {loading ? (
                  <span className="w-4 h-4 rounded-full border-2 animate-spin"
                    style={{ borderColor: 'rgba(0,0,0,0.2)', borderTopColor: '#000' }} />
                ) : (
                  <><BsLightningChargeFill /> Send Message</>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}